var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCriticalRisk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.717 7.045L6.433 1.183C6.137.655 5.59.33 4.998.33c-.592 0-1.138.325-1.434.853L.222 7.146c-.296.528-.296 1.178 0 1.706s.843.853 1.434.853h6.688c.914 0 1.656-.764 1.656-1.706 0-.353-.105-.682-.283-.954zm-4.01.57c0 .404-.301.713-.707.713-.406 0-.707-.309-.707-.712v-.017c0-.401.301-.712.707-.712.406 0 .707.309.707.712v.017zm.017-4.798l-.35 3.148c-.024.227-.17.368-.374.368s-.35-.143-.374-.368l-.35-3.15c-.023-.243.105-.427.325-.427h.796c.22.001.35.185.327.429z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalRisk);
export default __webpack_public_path__ + "static/media/critical-risk.c8ee862bc4c35e02eb1663ff113d9c33.svg";
export { ForwardRef as ReactComponent };